import React from 'react'
import { getTranslatedMessage, language } from '../utils/translations';
import {
	Row,
	IconButton,
	RateGoodIcon,
	RateBadIcon,
} from '@livechat/ui-kit'

const styles = {
	root: {
        direction: language === "en" ? "ltr" : "rtl",
        background: "white",
        padding: 10,
        margin: "0 15px",
        fontSize: 18,
        overflowY: "auto",
        height: "calc(100% - 100px)",
    },
    asterisk: {
        color: "red",
        fontSize: 12,
        fontWeight: 600,
        margin: "0 4px",
    },
    radio: {
        width: 20,
        height: 20,
        display: "inline-block",
        border: "1px solid rgb(190, 198, 207)",
        borderRadius: "50%",
        verticalAlign: "middle",
        margin: 3,
        cursor: "pointer",
    },
    label: {
        verticalAlign: "middle",
    },
    question: {
        margin: 0,
        lineHeight: '22px',
    },
    button: {
        margin: 10,
        width: 100,
        background: '#EEE',
        padding: '15px 45px',
        borderRadius: 4,
    }
};

const Asterisk = () => <span style={styles.asterisk}>*</span>;

class PostChatForm extends React.Component {
    state = {
        step: "q1",
        question1: 0,
        question2: 0,
    };

    onChoose = (question, value) => () => {
        this.setState({[question]: `${value}`});
        if (this.state.step === "q1") {
            this.setState({
                step: "q2",
            })
        } else if (this.state.step === "q2") {
            this.setState({
                step: "q3"
            })
        } else {
            this.props.onSubmit({
                question1: this.state.question1,
                question2: this.state.question2,
                question3: value,
            })
        }
    };


    render() {
        const { step } = this.state;
        return (
            <div style={styles.root}>
                {step === "q1" &&
                    <div>
                        <p style={styles.question}>{getTranslatedMessage("postQ1")} <Asterisk/></p>
                        {[1,2,3,4,5,6,7,8,9,10].map(c => (
                            <div key={c} onClick={this.onChoose("question1", c-1)}>
                                <div style={styles.radio} />
                                <span style={styles.label}>{c}</span>
                            </div>
                        ))}
                    </div>
                }
                {step === "q2" &&
                    <div>
                        <p style={styles.question}>{getTranslatedMessage("postQ2")}</p>
                        {[1,2,3,4,5].map(c => (
                            <div key={c} onClick={this.onChoose("question2", c-1)}>
                                <div style={styles.radio} />
                                <span style={styles.label}>{c}</span>
                            </div>
                        ))}
                    </div>
                }
                {step === "q3" &&
                    <div>
                        <p style={styles.question}>{getTranslatedMessage("postQ3")}</p>
                        <Row>
                            <IconButton style={styles.button} onClick={this.onChoose("question3", "good")}>
                                <RateGoodIcon />
                            </IconButton>
                            <IconButton style={styles.button} onClick={this.onChoose("question3", "bad")}>
                                <RateBadIcon />
                            </IconButton>
                        </Row>
                    </div>
                }
            </div>
        )
    }
}

export default PostChatForm



// WEBPACK FOOTER //
// ./src/components/PostChatForm.js